<!-- 水库详情 -->
<template>
  <div class="dialog-reservoir">
    <div class="header">
      <div class="title">{{ data.hkmc || '-' }}</div>
      <span class="btn" :class="videoShow ? 'active' : ''" @click="showVideoBox">视频</span>
    </div>
    <div class="body">
      <div class="content">
        <div class="descriptions-group">
          <h5>基本信息</h5>
          <div class="descriptions-item">
            <span class="key">水库类别:</span>
            <span class="value">{{ data.hkgm || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">所在乡镇:</span>
            <span class="value">{{ data.xzqhmc || '-' }}</span>
          </div>
          <!-- <div class="descriptions-item">
            <span class="key">集雨面积(K㎡):</span>
            <span class="value">{{ data.jymj || '-' }}</span>
          </div> -->
          <div class="descriptions-item">
            <span class="key">总库容（万m³）:</span>
            <span class="value">{{ data.zkr || '-' }}</span>
          </div>
          <!-- <div class="descriptions-item">
            <span class="key">正常库容（万m³）:</span>
            <span class="value">{{ data.zckr || '-' }}</span>
          </div> -->
          <div class="descriptions-item">
            <span class="key">死库容（万m³）:</span>
            <span class="value">{{ data.skr || '-' }}</span>
          </div>
        </div>
        <div v-show="false" class="descriptions-group">
          <h5>水质监测</h5>
          <div class="descriptions-item">
            <span class="key">监测类型:</span>
            <span class="value">{{ data.zcxsw || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">监测方式:</span>
            <span class="value">{{ data.ymqjxgc || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">目标水质:</span>
            <span class="value">{{ data.dbjsydmj || '-' }}</span>
          </div>
          <div class="descriptions-item">
            <span class="key">当前水质：</span>
            <span class="value">{{ data.skglfwmj || '-' }}</span>
          </div>
          <div class="descriptions-item2">
            <span class="key">主要污染物：</span>
            <span class="value">{{ data.skbhfwmj || '-' }}</span>
          </div>
        </div>
        <div v-show="false" class="descriptions-group">
          <div ref="chart" class="chart"></div>
        </div>
        <div v-show="videoShow" class="video-box descriptions-group">
          <n-select
            v-model:value="videoUrl"
            size="tiny"
            :options="videoList"
            @update:value="videoChange"
          />
          <video
            ref="video"
            controls
            autoplay
            class="video video-js vjs-default-skin vjs-big-play-centered"
          ></video>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Video from 'video.js'
import { toRefs, nextTick, getCurrentInstance, onMounted, onBeforeUnmount } from 'vue'
import { ref } from 'vue-demi'
const props = defineProps({
  data: Object,
})
const { data } = toRefs(props)
const { proxy } = getCurrentInstance()
const chart = ref()
const videoShow = ref(false)
const video = ref()
const videoUrl = ref()
const videoList = ref([])
let player: {
  pause(): unknown
  dispose: () => void
  on: (arg0: string, arg1: () => void) => void
  play: () => void
  ready: (arg0: () => void) => void
  currentTime: (arg0: number) => void
}
const myChart = {}
const testY = [0.12, '1', '', 0.15, 0.12, 0.25, 0.1, 0.41, 0.5, 0.2, 0.1, 0.4]
const testX = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
// if (myChart) {
//   myChart.clear()
// }
const max = 1
const option = {
  title: {
    show: false,
  },
  tooltip: {
    trigger: 'item',
  },
  grid: {
    show: true,
    top: 40,
    left: '6%',
    right: 45,
    bottom: 20,
    borderWidth: '0',
  },
  yAxis: {
    name: 'mg/L',
    nameTextStyle: {
      fontSize: 14,
      color: '#ffffff',
    },
    show: true,
    type: 'value',
    min: 0,
    max,
    splitLine: {
      show: true,
      lineStyle: {
        width: 2,
        dashOffset: 10,
        type: 'dashed',
        color: 'rgba(230, 247, 255, 0.2)',
      },
    },
    axisLabel: {
      formatter: '{value}',
      textStyle: {
        fontSize: 12,
        color: '#ffffff',
      },
    },
  },
  xAxis: {
    data: testX,
    boundaryGap: false,
    axisTick: {
      show: false,
    },
    axisLine: {
      show: true,
      lineStyle: {
        color: '#ffffff',
      },
    },

    axisLabel: {
      type: 'category',
      formatter: '{value}',
      // rotate: '45',
      textStyle: {
        fontSize: 12,
        color: '#ffffff',
      },
    },
  },
  series: [
    {
      name: 'title',
      type: 'line',
      color: '#09CEA5',
      smooth: false, // 关键点，为true是不支持虚线，实线就用true
      itemStyle: {
        normal: {
          lineStyle: {
            width: 2,
            type: 'dotted', // 'dotted'虚线 'solid'实线
          },
        },
      },
      markLine: {
        symbol: 'none',
        data: [
          {
            yAxis: 0.6,
            valueIndex: 1,
            // coord:['60','7'],
            lineStyle: {
              normal: {
                color: '#fd0',
                type: 'dashed',
              },
            },
            label: {
              normal: {
                // show: false,
                color: '#fd0',
                // position: 'insideEndBottom',
                formatter: '标准值',
              },
            },
          },
        ],
      },
      lineWidth: 2,
      symbol: '',
      symbolSize: 8,
      data: testY,
    },
  ],
}

const videoChange = (data) => {
  player.src({ src: data })
  player.play()
}

const showVideoBox = () => {
  videoShow.value = !videoShow.value
  if (videoShow.value) {
    if (player) {
      player.play()
    } else {
      const option = {
        muted: false,
        // controls: true,
        loop: false,
        autoplay: false,
        sources: [
          {
            type: '',
            src: videoUrl.value, // url地址
          },
        ],
        notSupportedMessage:
          videoList && videoList.length > 0
            ? '此视频暂无法播放，请稍后再试'
            : '该站点暂时未接入视频',
      }
      // 初始化的时候标签默认都是显示的
      player = Video(video.value, option, () => {
        player.on('error', () => {
          player.errorDisplay.contentEl().innerText = '现场视频断流，请稍后重试！'
          console.log('视频加载错误')
        })
      })
      player.play()
    }
  } else {
    player.pause()
  }
}

nextTick(() => {
  // myChart.setOption(option)
})
onMounted(() => {
  for (let i = 0; i < data.value.videoStream.length; i++) {
    videoList.value.push({ label: '视频' + (i + 1), value: data.value.videoStream[i] })
  }
  if (videoList.value[0]) {
    videoUrl.value = videoList.value[0].value
  }
  // myChart = proxy.$echarts.init(chart.value)
})

onBeforeUnmount(() => {
  setTimeout(() => {
    if (player) {
      player.dispose()
    }
  }, 200)
})
</script>

<style lang="scss" scoped>
.dialog-reservoir {
  width: 53.35rem;
  min-width: 53.35rem;
  .header {
    display: flex;
    text-align: left;
    margin-bottom: 5px;
    border-bottom: 1px solid #ddd;
    .title {
      font-family: Microsoft YaHei;
      font-style: normal;
      font-weight: bold;
      height: 32px;
      font-size: 16px;
    }

    .btn {
      margin-top: 2px;
      margin-left: 10px;
      width: 4rem;
      height: 2.2rem;
      line-height: 2.2rem;
      text-align: center;
      font-size: 1.3rem;
      color: #ffffff;
      cursor: pointer;
      background: rgba(102, 146, 138, 0.1);
      border: 0.025rem solid rgba(66, 196, 219, 0.8);
      box-sizing: border-box;
      border-radius: 0.1rem;
    }
    .active {
      background: #84c4f969;
    }
  }
  .body {
    .content {
      margin-bottom: 2rem;
      .descriptions-group {
        overflow: hidden;
        h5 {
          font-size: 14px;
          margin: 10px 0;
        }
        .descriptions-item {
          width: 50%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 12.8rem;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
        .descriptions-item2 {
          width: 100%;
          float: left;
          line-height: 2.65rem;
          margin-bottom: 1rem;
          &:last-of-type {
            margin-bottom: 1.4rem;
          }
          .key {
            display: inline-block;
            color: #ffffff;
            width: 12.8rem;
            margin-right: 1.9rem;
            text-align: left;
          }
        }
        .chart {
          width: 100%;
          height: 200px;
        }
      }
      .video-box {
        height: 34.05rem;

        .n-select {
          width: 8.4rem;
          margin-bottom: 0.4rem;
        }
        .video {
          width: 100%;
          height: calc(100% - 4.04rem);
          video {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
}
</style>
